import React from "react";
import Header from "../layouts/header";
import CandidatesIndex from "../components/candidates";

export default function Candidates() {

    return (
        <div>
            <Header />
            <CandidatesIndex />
        </div>
    )
};